export default (that) => [
  {
    field: 'seq',
    width: 80,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.type === 'checkbox',
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: that.type === 'radio',
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('INDEX.from_label_sample_style_no') || '样品款号',
    field: 'sampleStyleNo',
    width: 160,
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.from_label_sample_name_cn') || '样品中文名称',
    field: 'sampleName',
    minWidth: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('INDEX.table_label_productLine') || '产品线',
    field: 'v_productLine',
    minWidth: 120,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_Level_2_sample_classification') || '样品分类',
    field: 'v_categoryCode',
    minWidth: 120,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_sampleSource') || '样品来源',
    field: 'v_sampleSource',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_custName') || '客户',
    field: 'custName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_brandName') || '品牌',
    field: 'brandName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_customerProductNo') || '客人产品编号',
    field: 'customerProductNo',
    minWidth: 160,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_sampleSalesSeason') || '销售季节',
    field: 'v_sampleSalesSeason',
    minWidth: 120,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_sampleSpec') || '产品规格',
    field: 'specInfo',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'specInfo' },
  },
  {
    title: that.$l('INDEX.table_label_sampleWeight') || '产品重量',
    field: 'sampleWeight',
    minWidth: 100,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'weightInfo' },
  },
  {
    title: that.$l('INDEX.table_label_factory') || '成品工厂',
    field: 'scmName',
    minWidth: 160,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_factory_product_number') || '工厂产品编号',
    field: 'scmProductNo',
    minWidth: 160,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },

  {
    title: that.$l('INDEX.table_label_costMainType') || '主成本类型',
    field: 'v_costMainType',
    minWidth: 160,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_costPrice') || '成本价格',
    field: 'costPrice',
    minWidth: 160,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'costPriceInfo' },
  },
  {
    title: that.$l('INDEX.table_label_quotation_method') || '报价方式',
    field: 'v_quotedMethod',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_quotedPrice') || '建议报价',
    field: 'quotedPrice',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'quotedPriceInfo' },
  },
  {
    title: that.$l('INDEX.table_label_moq') || '起订量',
    field: 'moq',
    minWidth: 120,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'moqInfo' },
  },
  {
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    width: 170,
    title: that.$l('INDEX.creator') || '创建人',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    field: 'modifyByName',
    align: 'left',
    width: 170,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
